import { EditorAction, EditorActionTypes } from "../types/actions.editor";
import { ImportExportType } from "../types/importExport";
import { MenuConfig } from "../types/menu";
import { ModalConfig, ModalWithParams } from "../types/modal";

const initialState: {
    data: Record<string, any>[];
    indexer: string;
    importExportConfig: {
        importType: ImportExportType;
        exportType: ImportExportType;
    };
    menuConfig: MenuConfig;
    modal?: ModalWithParams;
    modalConfig?: ModalConfig;
    searchFilterKey?: string;
} = {
    data: [],
    indexer: "",
    menuConfig: {
        disableImportExport: false,
    },
    importExportConfig: {
        importType: ImportExportType.FORM,
        exportType: ImportExportType.EXCEL,
    },
    modal: undefined,
    modalConfig: undefined,
    searchFilterKey: undefined,
};

const editorReducer = (
    state = initialState,
    action: EditorActionTypes
): typeof initialState => {
    switch (action.type) {
        case EditorAction.SET_DATA:
            return {
                ...state,
                data: action.data,
                indexer: action.indexer,
            };
        case EditorAction.SET_EXPORT_TYPE:
            return {
                ...state,
                importExportConfig: {
                    ...state.importExportConfig,
                    exportType: action.exportType,
                },
            };
        case EditorAction.SET_IMPORT_TYPE:
            return {
                ...state,
                importExportConfig: {
                    ...state.importExportConfig,
                    importType: action.importType,
                },
            };
        case EditorAction.SET_SEARCH_FILTER_KEY:
            return {
                ...state,
                searchFilterKey: action.searchFilterKey,
            };
        case EditorAction.SET_MODAL_CONFIG:
            return {
                ...state,
                modalConfig: action.modalConfig,
            };
        case EditorAction.SET_MENU_CONFIG:
            return {
                ...state,
                menuConfig: action.menuConfig,
            };
        case EditorAction.TOGGLE_MODAL:
            return {
                ...state,
                modal: action.modal,
            };
        default:
            return state;
    }
};

export default editorReducer;
